<template>
  <div class="driverTaskDetail">
    <el-drawer
      size="70%"
      title="详情"
      :append-to-body="true"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
      <!-- <basic-container> -->
      <avue-form :option="option" v-model="form">
        <template slot="isTicket">
          {{ form.isTicket ? "是" : "否" }}
        </template>
        <template slot="blockTitle">
          <div class="custom-title">空车入场签单</div>
        </template>
        <template slot="blockTitle1">
          <div class="custom-title">回填入场签单</div>
        </template>
        <template slot="picTitleLabel">
          <div class="custom-title">图片</div>
        </template>
        <template slot="goPicture1Label"> 出场签单 </template>
        <template slot="ticketImg1Label"> 出场泥尾票 </template>
        <template slot="bdLabel"> 磅单 </template>
        <template slot="goPicture">
          <div class="pics">
            <div
              class="pic"
              v-for="(item, i) in getImage(form.goPicture)"
              @click="onPreview(item)"
              :key="i"
            >
              <img :src="item" alt="" />
            </div>
          </div>
        </template>
      </avue-form>
      <!-- </basic-container> -->
      <!-- <div class="footer">
     
        <div class="right">
          <el-button size="small" @click="cancelModal"> 取消</el-button>
          <el-button type="primary" size="small" @click="cancelModal">
            确定</el-button
          >
        </div>
      </div> -->
      <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[url]"
      :zIndex="9999"
    />
    </el-drawer>
   
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    detailForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showViewer: false,
      form: {},
      url: "",
    };
  },
  components: {
    ElImageViewer,
  },
  created() {},
  mounted: function () {
    this.form = this.detailForm;
  },
  methods: {
    onPreview(item) {
      this.url = item;
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    getImage(val) {
      if (val) {
        return val.split(",");
      }
      return [];
    },
    cancelModal() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  // margin-bottom: 10px;
  margin-bottom: 0;
}
/deep/ .avue-upload .el-icon-plus {
  display: none;
}
/deep/ .avue-upload--list .el-upload {
  border: none;
  .avue-upload__avatar {
    width: 100px;
    height: 100px;
  }
}
/deep/.el-form-item {
  display: flex;
  // align-items: center;
  margin-bottom: 0 !important;

  .el-form-item__label {
    // line-height: 20px;
    padding-right: 0;
    white-space: nowrap;
    width: auto !important;
  }
  .el-form-item__content {
    margin-left: 0 !important;
    padding-left: 0;
  }
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 160px !important;
  height: 90px !important;
}
.custom-title {
  font-weight: 500;
  font-size: 14px;
  color: #313133;
  margin-top: 25px;
  margin-bottom: 8px;
}
.pics {
  .pic {
    width: 160px;
    height: 90px;
    margin-bottom: 10px;
    cursor: pointer;
    img {
      border-radius: 4px;
      width: 100%;
      height: 100%;
    }
  }
}
/deep/.custom-pics {
  display: block !important;
}
/deep/.el-form-item .el-form-item__content {
  width: 100%;
}
.footer {
  padding: 16px 24px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 1px solid #ededf0;
}
/deep/.el-drawer__header {
  border-bottom: 1px solid #ededf0 !important;
  padding-bottom: 20px;
}
/deep/.avue-form__tabs {
  padding: 0;
}
/deep/.el-tabs__nav-wrap::after {
  height: 1px;
}
/deep/.el-tabs__item {
  height: 48px;
  line-height: 48px;
}
/deep/.avue-form {
  padding: 0 32px;
}
/deep/.el-col {
  padding-left: 10px !important;
}
</style>
